import { Card, CardBody } from 'components/card';
import { CardHeader, CardHeaderTitle } from 'components/card/card-header';
import FormEditHeaderButtons from 'containers/partials/buttons/FormEditHeaderButtons';
import FormEditFooterButtons from 'containers/partials/buttons/FormEditFooterButtons';
import { FormattedMessage } from 'react-intl';
import messages from 'messages';
import IssueDetailFields from 'containers/pages/rehab/issue/IssueDetailFields';
import IssueForm from 'containers/pages/rehab/issue/IssueForm';
import useEdit from 'hooks/utils/useEdit';
import { useContext, useEffect } from 'react';
import { StoreContext } from 'index';
import { useParams } from 'react-router-dom';
import { useContextMenu } from 'contexts/ContextMenuProvider';
import RemovePersonIssueButton from 'containers/partials/buttons/RemoveIssueButton';

function IssueDetailsTab({ personIssue, medical, ...props }) {
  const {
    authStore: { user }
  } = useContext(StoreContext);
  const { entityId, personId, groupId, issueId } = useParams();
  const [edit, setEdit] = useEdit(props.edit, true);
  const { setMenuItems, clearAllContext } = useContextMenu();

  useEffect(() => {
    const contextMenuItems = [];
    if (user.canRemovePersonInjury(entityId)) {
      contextMenuItems.push(
        <RemovePersonIssueBtn key="remove-person-issue-btn" />
      );
    }
    setMenuItems(contextMenuItems);
    return () => clearAllContext();
  }, [entityId, issueId]);

  const RemovePersonIssueBtn = () => (
    <RemovePersonIssueButton
      menu
      entityId={entityId}
      personId={personId}
      groupId={groupId}
      personIssueId={issueId}
    >
      <FormattedMessage {...messages.rehabMenuItemRemovePersonIssue} />
    </RemovePersonIssueButton>
  );

  return (
    <Card secondary>
      <IssueForm
        entityId={entityId}
        personId={personId}
        personIssue={personIssue}
        medical={medical}
      >
        {({ submitForm, resetForm }) => (
          <>
            <CardHeader secondary>
              <CardHeaderTitle>
                <FormattedMessage {...messages.titleIssueDetails} />
              </CardHeaderTitle>
              <FormEditHeaderButtons
                edit={edit}
                setEdit={setEdit}
                onCancel={resetForm}
                onSubmit={submitForm}
                type={'button'}
              />
            </CardHeader>
            <CardBody secondary>
              <IssueDetailFields edit={edit} />
            </CardBody>
            <FormEditFooterButtons
              edit={edit}
              setEdit={setEdit}
              onCancel={resetForm}
              onSubmit={submitForm}
              type={'button'}
            />
          </>
        )}
      </IssueForm>
    </Card>
  );
}

export default IssueDetailsTab;
